module.exports = __webpack_public_path__ + "static/media/VNM.bef66992.svg";